<header class="main-header">
  <div class="header-inner">
    <a class="brand" routerLink="/invoices" aria-label="Suburban Supply home">
      <img ngSrc="logo.svg" alt="" class="logo" priority height="25" width="25" />
      <span>Suburban Supply</span>
    </a>

    <div class="header-spacer"></div>

    <div #userMenu class="user-menu" [class.open]="isUserMenuOpen()">
      <button
        class="user-chip"
        type="button"
        aria-haspopup="true"
        [attr.aria-expanded]="isUserMenuOpen()"
        (click)="$event.stopPropagation(); toggleUserMenu()"
      >
        <span class="avatar">{{ user().initials }}</span>
        <span class="user-chip-name">{{ user().displayName }}</span>
        <span class="user-chip-chevron" aria-hidden="true"></span>
      </button>

      @if (isUserMenuOpen()) {
        <div class="user-dropdown" role="menu" (click)="$event.stopPropagation()">
          <div class="ud-identity">
            <span class="avatar avatar-lg">{{ user().initials }}</span>
            <div>
              <div class="ud-name">{{ user().displayName }}</div>
              @if (user().email) {
                <div class="ud-email">{{ user().email }}</div>
              }
            </div>
          </div>

          @if (user().phone) {
            <div class="ud-divider"></div>
            <div class="ud-row">
              <span class="ud-row-label"><i class="app-icon app-icon-phone"></i> Phone</span>
              <span class="ud-row-value">{{ user().phone }}</span>
            </div>
          }

          <div class="ud-divider"></div>

          <button class="ud-action danger" type="button" role="menuitem" (click)="logout()">
            <i class="app-icon app-icon-sign-out"></i>
            Log Out
          </button>
        </div>
      }
    </div>
  </div>
</header>
